import React, { useContext, useState } from "react";
import Close from "../../../../../../../images/Close.svg";
import { Tab, Tabs } from "@mui/material";
import { a11yProps, TabPanel } from "../../../../../../../styles/Tabs";
import AssetDetails, { AssetDetailsPageFor } from "./AssetDetails";
import { TableType } from "../../../../../customer/companies/queries/types";
import { StateTypes } from "../../../Maps";
import { MapsContext } from "../../../context/context";
import { mapsPayloadType } from "../../../context/reducer";

export interface RaisedTicketDetailsProps {
  setModalFlag: React.Dispatch<React.SetStateAction<StateTypes>>;
  assetType: TableType;
  pageFor: AssetDetailsPageFor;
  itemsView?: boolean;
}
const RaisedTicketDetails = ({
  setModalFlag,
  assetType,
  pageFor,
  itemsView,
}: RaisedTicketDetailsProps) => {
  const [value, setValue] = useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const { dispatch } = useContext(MapsContext);

  return (
    <div className="junc-raised-ticket">
      <div className="junc-raised-ticket__title">
        <img
          src={Close}
          alt=""
          onClick={() => {
            setModalFlag({
              flag: false,
              itemId: 0,
              tableLevel: TableType.COMPANY,
            });
            dispatch({
              type: mapsPayloadType.TICKET,
              payload: {
                ticketId: 0,
              },
            });
          }}
        />
      </div>
      <div className="junc-raised-ticket__tabs">
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Ticket Details" value={0} {...a11yProps(0)} />

          {/* <Tab label="History" value={1} {...a11yProps(1)} /> */}
        </Tabs>
      </div>
      <div className="junc-raised-ticket__tab-panel">
        <TabPanel value={value} index={0}>
          <AssetDetails
            setModalFlag={setModalFlag}
            assetType={assetType}
            pageFor={pageFor}
            itemsView={itemsView}
          />
        </TabPanel>
        <TabPanel value={value} index={1}></TabPanel>
      </div>
    </div>
  );
};

export default RaisedTicketDetails;
